import React from 'react';
import LanguageIcon from '@mui/icons-material/Language';
import { Overview } from './Overview';
import { FailureDefinition } from './FailureDefinition';
import { DeteriorationModel } from './DeteriorationModel';
import { AssetDetails } from './AssetDetails';
import { addRouteNamespace } from '@Utils/actions';

export const ROUTES = {
	overview: {
		key: 'overview',
		title: 'Deterioration Analysis',
		path: addRouteNamespace(''),
		component: <Overview />,
		breadcrumbs: [
			{
				title: 'Analysis',
				link: '/analysis',
			},
		],
	},
	failureDefinitionNew: {
		key: 'failureDefinitionNew',
		title: 'Failure Definition',
		path: addRouteNamespace('failure-definition/new'),
		component: <FailureDefinition />,
		breadcrumbs: [
			{
				title: 'Deterioration Analysis',
				link: addRouteNamespace(''),
			},
		],
	},
	failureDefinitionEdit: {
		key: 'failureDefinitionEdit',
		title: 'Failure Definition',
		path: addRouteNamespace('failure-definition/:id'),
		component: <FailureDefinition />,
		breadcrumbs: [
			{
				title: 'Deterioration Analysis',
				link: addRouteNamespace(''),
			},
		],
	},
	deteriorationModel: {
		key: 'deteriorationModel',
		title: 'New Deterioration Model',
		path: addRouteNamespace('models/:id'),
		component: <DeteriorationModel />,
		breadcrumbs: [
			{
				title: 'Analysis',
				link: '/analysis',
			},
			{
				title: 'Deterioration Model',
				link: addRouteNamespace(''),
			},
		],
	},
	assetDetails: {
		key: 'assetDetails',
		title: 'Asset Details',
		path: addRouteNamespace('asset-details/:assetType/:assetId'),
		component: <AssetDetails />,
		breadcrumbs: [],
	},
};

export const mainPageRoutes = Object.values(ROUTES).map(route => ({
	title: route.title,
	to: route.path,
	render: route.component,
}));

export const miniPageRoutes = [
	{
		title: 'Deterioration Modelling',
		to: addRouteNamespace(''),
		icon: <LanguageIcon />,
		render: <Overview />,
	},
	...mainPageRoutes,
];

export default [mainPageRoutes, miniPageRoutes];
